import { Component, OnInit } from '@angular/core';
import { Source } from '../../models/source';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItems } from '../../../../shared/Models/SelectItems';
import { SourceMasterService } from '../../services/source.master.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-create-form',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateDataSourceComponent implements OnInit {
  source: Source = {} as Source;
  activityTypesOptions: SelectItems[];

  constructor(
    private service: SourceMasterService,
    private router: Router,
    private diag: NbDialogRef<CreateDataSourceComponent>,
    private toast: NbToastrService,
  ) {}

  ngOnInit() {}

  dropdownChange($event) {}
  save() {
    this.service.post(this.source).subscribe((res) => {
      this.toast.success('Add source successfully', 'success', {duration: 4000});
      this.diag.close('true')
    });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
